<ng-container *ngIf='variableMap'>
  <shared-ui-information-element [information]='getInformationElementStudentFullname()'></shared-ui-information-element>
  <shared-ui-information-element [information]='getMasterstudium()'></shared-ui-information-element>
</ng-container>
